import { pdf, usePDF } from "@react-pdf/renderer";
import LeaseLicense from "lib/components/practitioners/lease-license";
import { formatDate, getTimePart } from "lib/utils/date-utils";
import { DateTime } from "luxon";

interface LicenseState {
  // loading: boolean;
  // error: string | null;

  createLicenses: (
    details: LicenseDetails,
    onSuccess?: (license: File) => void
  ) => Promise<File>;
}

const useLicense = (): LicenseState => {
  //const [instance, updateInstance] = usePDF();

  const createLicenses = async (
    details: LicenseDetails,
    onSuccess?: (license: File) => void
  ) => {
    const document = <LeaseLicense {...details} />;

    const pdfInstance = pdf(document);

    const doc = await pdfInstance.toBlob();

    //updateInstance(document);

    if (doc) {
      const filename = (
        details?.licenseeName +
        "-" +
        new Date().getDay() +
        new Date().getMonth() +
        new Date().getFullYear() +
        "-" +
        getTimePart(new Date()) +
        `-No-${(details?.index ?? 0) + 1}` +
        "-license.pdf"
      )
        .replaceAll(" ", "-")
        .replaceAll(":", "-");

      const licenseFile = new File([doc], filename, {
        type: "application/pdf",
      });

      onSuccess?.(licenseFile);
      return Promise.resolve(licenseFile);
    }
  };

  return { createLicenses };
};

export default useLicense;
